import React, { useState, useEffect } from "react";
import coinGecko from "../../assets/js/coinGecko";
import ReactApexChart from 'react-apexcharts';
import './css/TRXChart.css'

const TRXChart = (props) => {

    const [trxHistoryINR, setTRXHistoryINR] = useState([])
    const [trxHistoryUSD, setTRXHistoryUSD] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const formatData = data => {
        return data.map((el) => {

            return {
                x: el[0],
                y: el[1]
            }
        })
    }

    useEffect(() => {
        const fetchcoinDetails = async () => {

            setIsLoading(true)


            return await Promise.all([
                coinGecko.get(`/coins/tron/market_chart/`, {
                    params: {
                        vs_currency: "inr",
                        days: "1",
                    }
                }),
                coinGecko.get(`/coins/tron/market_chart/`, {
                    params: {
                        vs_currency: "usd",
                        days: "1",
                    }
                })
            ])



        }

        fetchcoinDetails().then((res) => {
            setTRXHistoryINR(formatData(res[0].data.prices))
            setTRXHistoryUSD(formatData(res[1].data.prices))
        })

        setIsLoading(false)

    }, [])

    let series;

    if (!window.localStorage.getItem('CurrentCurrency') || window.localStorage.getItem('CurrentCurrency') === 'inr') {

        series = [{
            name: "TRX",
            data: trxHistoryINR,
        }]

    } else {
        series = [{
            name: "TRX",
            data: trxHistoryUSD,
        }]

    }

    let options = {
        chart: {
            zoom: {
                enabled: false,
            },
            toolbar: {
                show: false,
            },
            height: 315,
            type: 'area'
        },
        colors: ['#ffb628'],
        grid: {
            show: false,
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth'
        },
        xaxis: {
            tooltip: {
                enabled: false
            },
            type: 'datetime',
            labels: {
                show: false,
                formatter: function (value, timestamp) {
                    return new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                },
            }
        },
        yaxis: {
            show: false,
            labels: {
                formatter: function (val, index) {
                    if (window.localStorage.getItem('CurrentCurrency') === 'inr') {
                        return val.toFixed(2) + " INR";
                    } else {
                        return val.toFixed(2) + " USD";
                    }

                }
            }
        },
        tooltip: {
            x: {
                format: 'dd/MM/yy HH:mm'
            },
        },
    }

    const renderChart = () => {
        if (isLoading) {
            return <>Loading....</>
        }
        return (
            <>

                <ReactApexChart options={options} series={series} type="area" height={315} />

            </>
        )
    }

    return (
        <>
            {renderChart()}
        </>
    )

}

export default TRXChart;